import { SegmentedControl } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useDomain, Domain } from "../../DomainContext";

export interface DomainSelectorProps {
    // Invoked when the user toggles the selector. When omitted, the domain context
    // setter is used directly. Provide this to run side-effects (e.g. resetting the
    // conversation) on a user-initiated switch.
    onDomainChange?: (domain: Domain) => void;
}

export const DomainSelector = ({ onDomainChange }: DomainSelectorProps) => {
    const { t } = useTranslation();
    const { domain, setDomain } = useDomain();

    return (
        <SegmentedControl<Domain>
            size="xs"
            radius="xl"
            color="blue"
            value={domain}
            onChange={onDomainChange ?? setDomain}
            data={[
                { value: "human", label: t("domain.human") },
                { value: "vet", label: t("domain.vet") }
            ]}
        />
    );
};
